
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { OffcanvasComponent } from './components/offcanvas/offcanvas.component';
import { TooltipComponent } from './utilities/html-elements/tooltip/tooltip.component';
import { TooltipDirective } from './utilities/html-elements/tooltip/tooltip.directive';

@NgModule({
    declarations: [
        OffcanvasComponent,
        TooltipComponent,
        TooltipDirective
  ],
    imports: [
        CommonModule,
        ImageCropperComponent
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,
        InfiniteScrollModule,
        ImageCropperComponent,
        OffcanvasComponent,
        TooltipDirective

    ],
    providers: [
    ]
})

export class WinoSharedModule { }